export const BASEURL = `https://testing.ppaska.id/api/contact`